var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg75(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_1249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 6.66671C7.64605 6.66671 7.30691 6.80718 7.05687 7.05723C6.80682 7.30728 6.66634 7.64642 6.66634 8.00004C6.66634 8.68004 6.59967 9.67337 6.49301 10.6667M9.33301 8.74671C9.33301 10.3334 9.33301 13 8.66634 14.6667M11.5263 14.0134C11.6063 13.6134 11.813 12.48 11.8597 12M1.33301 8.00004C1.33301 6.60082 1.77326 5.23708 2.59139 4.10197C3.40953 2.96687 4.56408 2.11796 5.89149 1.67549C7.2189 1.23301 8.65189 1.21942 9.98746 1.63662C11.323 2.05382 12.4935 2.88067 13.333 4.00004M1.33301 10.6667H1.33967M14.533 10.6667C14.6663 9.33337 14.6203 7.09737 14.533 6.66671M3.33301 13C3.66634 12 3.99967 10 3.99967 8.00004C3.999 7.54595 4.07565 7.09506 4.22634 6.66671M5.76634 14.6667C5.90634 14.2267 6.06634 13.7867 6.14634 13.3334M5.99967 4.53337C6.60794 4.18219 7.29795 3.99736 8.00032 3.99748C8.70268 3.99759 9.39263 4.18264 10.0008 4.53402C10.6089 4.88539 11.1138 5.39071 11.4647 5.99914C11.8156 6.60758 12.0001 7.29768 11.9997 8.00004V9.33337",
    stroke: "#FFDC84",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_1249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg75);
export default __webpack_public_path__ + "static/media/svg75.73fa1e75806fb231d63b933c2a7af460.svg";
export { ForwardRef as ReactComponent };